export var previewDataURLFile = fileDataURL => {
  if (!fileDataURL) return;
  var win = window.open();
  win === null || win === void 0 ? void 0 : win.document.write( // eslint-disable-next-line @typescript-eslint/no-base-to-string
  "<iframe width=\"100%\" height=\"100%\" src=".concat(fileDataURL.toString(), " frameborder=\"0\" allowfullscreen></iframe>"));
};
export function getPreviewFileMetadata(file, fileDataURL) {
  if (!file) {
    return null;
  }

  var isFile = file instanceof File;
  var isFileInfo = !isFile && typeof (file === null || file === void 0 ? void 0 : file.url) == 'string';

  if (!isFile && !isFileInfo) {
    return null;
  }

  if (isFile) {
    if (!fileDataURL) {
      return null;
    } // eslint-disable-next-line @typescript-eslint/no-base-to-string


    return {
      url: fileDataURL.toString(),
      type: file.type,
      name: file.name
    };
  }

  return file;
}
//# sourceMappingURL=_BaseFileUpload.utils.js.map